import { useCallback, useEffect, useState } from "react";
//Components
import TranslationText from "../../atoms/TranslationText";
import LanguageToggler from "../LanguageToggler";
import ProjectItem from "../ProjectItem";
//Styles
import "./styles.scss";

function RightContainer() {
  const [languagesColor, setLanguagesColor] = useState<"light" | "dark">(
    "light"
  );

  /**
   * Changes language toggler styles to match them with where it's positioned
   * according to the current width (media queries set breakpoints)
   */
  const measureScroll = useCallback(() => {
    const scrollYPos = window.scrollY;
    const innerHeight = window.innerHeight;
    if (scrollYPos >= innerHeight && languagesColor !== "dark") {
      setLanguagesColor("dark");
    } else if (scrollYPos <= innerHeight && languagesColor !== "light") {
      setLanguagesColor("light");
    }
  }, [languagesColor]);

  //To listen for scroll change
  useEffect(() => {
    window.addEventListener("scroll", measureScroll);

    return () => {
      window.removeEventListener("scroll", measureScroll);
    };
  }, [measureScroll]);

  return (
    <div className="right-container">
      <div
        className={`right-container__languages-container right-container__languages-container--${languagesColor}`}
      >
        <LanguageToggler />
      </div>
      <TranslationText
        styles="right-container__title"
        jsonKeysPath={"home.title"}
      />
      <ProjectItem
        description="projects.weatherApp.description"
        thumbnail="https://storage.googleapis.com/personal-a-dev-bucket/portfolio/thumbnails/weatherapp.png"
        title="Weather App"
        siteUrl="https://unrivaled-custard-408fd3.netlify.app/"
        repoUrl="https://github.com/a-flowers-a/weather-app"
      />
      <ProjectItem
        description="projects.polilibro.description"
        thumbnail="https://storage.googleapis.com/personal-a-dev-bucket/portfolio/thumbnails/polilibro.png"
        title="Polilibro"
        siteUrl="https://thirsty-engelbart-1b9acf.netlify.app/"
        repoUrl="https://github.com/a-flowers-a/libro2"
      />
      <ProjectItem
        description="projects.dogMatch.description"
        thumbnail="https://storage.googleapis.com/personal-a-dev-bucket/portfolio/thumbnails/dogmatch.png"
        title="Dog Match"
        siteUrl="https://precious-platypus-d8bb5c.netlify.app/"
        repoUrl="https://github.com/a-flowers-a/dog-match"
      />
      <ProjectItem
        description="projects.drugtest.description"
        thumbnail="https://storage.googleapis.com/personal-a-dev-bucket/portfolio/thumbnails/drugtest.png"
        title="Drugtest"
        siteUrl="https://github.com/a-flowers-a/drugtest"
      />
    </div>
  );
}

export default RightContainer;
